const size = {
  mobileMax: "768px",
  tabletMax: "1023px",
};

export const device = {
  mobileMax: `(max-width: ${size.mobileMax})`,
  tabletMax: `(max-width: ${size.tabletMax})`,
};
